<template>
	<div class="learner_dashboard inst_switch">

		<div class="row">
			<div class="col-12 sec_tp_msg ace_sec pg_hd">
				<span>You have signed up to explore these institutions, click on the institution below to start exploring.</span>
			</div>
		</div>

    <div class="row comp_row">
      <div class="col-12">
        <div class="row long_row inst_list_container">
          <div v-for="(institution, i) in institutions" class="col-3 explore_intro">
            <div class="pkg_entity_bx programs">
              <button @click.stop="changeInstitution(institution)" class="ace_sec" :aria-label="'institution ' + institution.name" tabindex="0">
                <div class="bx_inner">
                  <div class="thumbnail_container">
                    <div class="thumbnail_img" v-if="institution.logo">
                      <img v-bind:src="institution.logo" alt="Institution Logo"></img>
                    </div>
	                	<div class="default_thumbnail" v-else>
											<span class="btn_ic ic-inst"></span>
										</div>
	              	</div>
									<div class="inst_name">
										{{institution.title}}
									</div>
								</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

      <div>
        <b-modal v-model="showSSOModal" title="Log in with your institution" no-close-on-backdrop no-close-on-esc centered>
            <div class="text-center">
                    <div class="float-left mr-3">
                        <div class="fld-label">Looks like you have an account with <b><i>{{ssoInstitutionName}}</i></b></div>
                        <div class="fld-label"> </div>
                        <div class="fld-label">Please click on the button below to log in with your <b><i>{{ssoInstitutionName}}</i></b> credentials. </div>
                    </div>
            </div>
            <div slot="modal-footer" class="w-100">
                    <img :src="ssoInstitutionLogo" height=40px width=80px v-if="ssoInstitutionLogo">
                    <b-button variant="primary" size="sm" class="float-right ml-3" @click="institutionLogin">go to institution login</b-button>
            </div>
        </b-modal>
    </div>

	</div>
</template>

<script>
	import { mapActions } from 'vuex'
	import { StorageFactory } from '../../../storageFactory'


export default {
	name: 'switch-institution',
	data: () => {
		return {
        	institutions: [],
          showSSOModal: false,
          ssoPath : undefined,
          ssoInstitutionName:undefined,
          ssoInstitutionLogo:undefined,

		}
	},
    created () {
      this.populateInstitutions()
    },
methods: {
	...mapActions([
		  'loadChangeUserInstitution',
	      'loadAllUserInstitution',
	      'setUserInfo'
	    ]),
  populateInstitutions () {
        this.loadAllUserInstitution().then(resp => {
          this.institutions = resp
        })
  },
  navigateToDashboard (userRole) {
        let role = userRole.toLowerCase()
        let url = '/user/track/' + role
        if ((role === 'instructor & admin') || (role === 'curator')) {
          url = '/user/track/admin'
        } else if (role === 'employer admin') {
          url = '/employer/admin'
        } else if (role === 'prospective student' || role === 'admitted student') {
          url = '/user/track/' + role.split(' ').join('_')
        } else if (role === 'widget admin') {
          url = '/user/track/' + role.split(' ').join('_')
        }
        this.$router.push(url)
        setTimeout(() => {
            window.location.reload()
          }, 500)

    },
    checkSSOEnabled (institution) {
        if(institution.path){
            this.showSSOModal = true
            this.ssoPath = institution.path
            this.ssoInstitutionName = institution.title
            this.ssoInstitutionLogo = institution.logo
            return true
        }
        return false
    },
    institutionLogin () {
        window.location.href = window.location.origin + '/sso/' + this.ssoPath

      } ,
  changeInstitution (institution) {
          if(this.checkSSOEnabled(institution)){
              return
          }
          this.loadChangeUserInstitution(institution.uuid).then(res => {
            this.$store.commit('LOAD_ALL_CHANNELS', [])
            this.$store.commit('LOAD_LEARNING_SPACES', [])
            let status = res.status
            let userObj = res.data
            if (status === 200) {
                this.setUserInfo(userObj)
                let userRole = userObj.roles[0].role
                let role = userRole.toLowerCase()
                this.navigateToDashboard(role)
            }
          })
      }
	}
}
</script>

<style scoped>
  .career-thumbnail {
    padding-top: 0px;
  }

  .career-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 18px !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionSwitch.vue